import React from 'react';
import { useManaSymbols, parseManaSymbols } from '../hooks/useManaSymbols';
interface Props {
  manaCost:  string | null | undefined;
  size?:     number;   // px, default 16
  className?: string;
}
/**
 * Renders a Scryfall mana cost string as inline symbol images.
 * e.g. "{2}{U}{U}" renders three symbol images side by side.
 * Handles DFC cards: "{1}{G} // {5}{G}{G}" renders both faces with a // separator.
 * Falls back to plain text token if symbol image not found.
 */
export default function ManaCost({ manaCost, size = 16, className }: Props) {
  const symbols = useManaSymbols();
  const tokens  = parseManaSymbols(manaCost);
  if (tokens.length === 0) return null;
  return (
    <span className={`mana-cost ${className ?? ''}`} style={{ display: 'inline-flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
      {tokens.map((token, i) => {
        // DFC face separator
        if (token === '//') {
          return (
            <span key={i} style={{
              fontSize: size * 0.75,
              color: 'var(--text-secondary, #606080)',
              padding: '0 3px',
              fontFamily: 'monospace',
              fontWeight: 700,
              opacity: 0.7,
            }}>
              //
            </span>
          );
        }
        const sym = symbols[token];
        if (sym?.imageUrl) {
          return (
            <img
              key={i}
              src={sym.imageUrl}
              alt={sym.english ?? token}
              title={sym.english ?? token}
              width={size}
              height={size}
              style={{ display: 'inline-block', verticalAlign: 'middle' }}
            />
          );
        }
        // Fallback — plain text for unknown symbols
        return (
          <span
            key={i}
            title={token}
            style={{
              fontSize: size * 0.7,
              background: 'rgba(255,255,255,0.1)',
              borderRadius: 3,
              padding: '0 3px',
              fontFamily: 'monospace',
              color: 'var(--text-secondary)',
            }}
          >
            {token}
          </span>
        );
      })}
    </span>
  );
}
